// extracted by mini-css-extract-plugin
export default {"centerText":"eL5apbLN4gwrAR8cAqwY","wrapper":"ptI4nrkEcMpIvpkz_lsW"};